import styled from "styled-components";
import { MENU_COLORS } from "@lhd/constants";
interface StyledButtonProps {
  isFull?: boolean;
}
export const StyledButton = styled.div<StyledButtonProps>`
  ${({ isFull }) => isFull && "width: 100%;"}

  .button-back-common {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${MENU_COLORS.TEXT_WHITE};
    color: ${MENU_COLORS.PRIMARY};
    padding: 0px 8px;
    font-size: inherit;
    cursor: pointer;
    border-radius: 4px;
    min-width: 60px;
    line-height: 1;
    box-sizing: border-box;
    border: 1px solid ${MENU_COLORS.PRIMARY};
    .button-content {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      gap: 6px;
    }

    .button-loading,
    .button-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }

    .button-text {
      display: block;
      line-height: 1;
      white-space: nowrap;
      transform: translateY(0px);
    }

    &:hover {
      color: ${MENU_COLORS.ACTIVE};
    }

    &.hidden {
      background-color: transparent;
    }
    &:disabled {
      background-color: ${MENU_COLORS.DISABLED_BUTTON};
      cursor: not-allowed;
      color: ${MENU_COLORS.TEXT_WHITE} !important;
      font-weight: 400;
    }
    &.notEditable {
      cursor: default;
      background-color: ${MENU_COLORS.DISABLED_BUTTON};
    }
    .icon {
      display: flex;
      align-items: center;
    }
  }
`;
